<script setup>
import feather from 'feather-icons';
const props = defineProps({
  name: { type: String, required: true },
  iconClass: { type: String, default: '' },
});
const svg = feather.icons[props.name]?.toSvg({ class: props.iconClass }) ?? '';
</script>

<template>
  <span v-html="svg" aria-hidden="true" />
</template>

